import styled from 'styled-components';

export const StyledContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: ${({ disableIncrement }) => (disableIncrement ? 'default' : 'pointer')};
`;

export const StyledCounterWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledMultiAddOnWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${props => props.theme.space[2]}px 0;
`;
